import { createFileRoute, redirect } from "@tanstack/react-router";
import { blackScheduledHref } from "@/lib/black2x1/offer-rules";
import logoOficial from "@/assets/black2x1/black-logo-oficial.webp.asset.json";
import { Black2x1Page } from "@/components/black2x1/Black2x1Page";

const URL = "https://fisioemortopedia.com.br/black-lista-entregas";

export const Route = createFileRoute("/black-lista-entregas")({
  beforeLoad: ({ location }) => {
    const destination = blackScheduledHref(location.href, Date.now());
    if (destination !== location.href) throw redirect({ href: destination, statusCode: 302 });
  },
  head: () => ({
    meta: [
      { title: "Seu material chegou · BLACK FEO 2026 · Pós em Dobro" },
      { name: "description", content: "Seu material gratuito já está no seu e-mail. Entre no grupo da BLACK FEO 2026 e receba a oferta Pós em Dobro: 2 pós pelo preço de 1." },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: "BLACK FEO 2026 · Pós em Dobro" },
      { property: "og:description", content: "Seu material gratuito já está no seu e-mail. Entre no grupo e receba a oferta Pós em Dobro." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: URL }, { rel: "preload", as: "image", href: logoOficial.url, fetchPriority: "high" }],
  }),
  component: () => <Black2x1Page mode="lista" variant="entregas" />,
});
